var _rect, _path, _g, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-2494 -1946C-2494 -1947.1 -2493.1 -1948 -2492 -1948H4662C4663.1 -1948 4664 -1947.1 4664 -1946V6136C4664 6137.1 4663.1 6138 4662 6138H-2492C-2493.1 6138 -2494 6137.1 -2494 6136V-1946Z",
    fill: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_2750_322870)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2750_322870)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -24,
    y: -382,
    width: 512,
    height: 589,
    rx: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 456,
    transform: "translate(-24 -321)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2750_322870)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9 1H5.1L1 5.1V10.9L5.1 15H10.9L15 10.9V5.1L10.9 1ZM7 4H9V8H7V4ZM9 10H7V12H9V10Z",
    fill: "#C70F49"
  }))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-2492 -1947H4662V-1949H-2492V-1947ZM4663 -1946V6136H4665V-1946H4663ZM4662 6137H-2492V6139H4662V6137ZM-2493 6136V-1946H-2495V6136H-2493ZM-2492 6137C-2492.55 6137 -2493 6136.55 -2493 6136H-2495C-2495 6137.66 -2493.66 6139 -2492 6139V6137ZM4663 6136C4663 6136.55 4662.55 6137 4662 6137V6139C4663.66 6139 4665 6137.66 4665 6136H4663ZM4662 -1947C4662.55 -1947 4663 -1946.55 4663 -1946H4665C4665 -1947.66 4663.66 -1949 4662 -1949V-1947ZM-2492 -1949C-2493.66 -1949 -2495 -1947.66 -2495 -1946H-2493C-2493 -1946.55 -2492.55 -1947 -2492 -1947V-1949Z",
    fill: "black",
    fillOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_2750_322870",
    x: -59,
    y: -387,
    width: 582,
    height: 664,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 35
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.133333 0 0 0 0 0.145098 0 0 0 0 0.184314 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2750_322870"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.133333 0 0 0 0 0.145098 0 0 0 0 0.184314 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2750_322870",
    result: "effect2_dropShadow_2750_322870"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2750_322870",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2750_322870"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -24,
    y: -382,
    width: 512,
    height: 589,
    rx: 6,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2750_322870"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextError);
export default __webpack_public_path__ + "static/media/text-error.74e9b0bb26ba49828f42dca469945c01.svg";
export { ForwardRef as ReactComponent };